import { render, staticRenderFns } from "./EducationalGroupFinish.vue?vue&type=template&id=6a5b1d5e&"
import script from "./EducationalGroupFinish.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports